import TooltipsCard from './TooltipsCard';

export default TooltipsCard;
